export default {
  install(Vue) {
    Vue.prototype.$goBack = function goBack() {
      this.$router.go(-1);
    };

    Vue.prototype.$toggleItemPreenchidoBarraProgresso = function toggleItemPreenchidoBarraProgresso(
      item,
      shouldAdd,
      itemsPreenchidos = []
    ) {
      if (!Array.isArray(itemsPreenchidos)) {
        return shouldAdd ? [item] : [];
      }

      const index = itemsPreenchidos.indexOf(item);

      if (shouldAdd && index === -1) {
        itemsPreenchidos.push(item);
      } else if (!shouldAdd && index > -1) {
        itemsPreenchidos.splice(index, 1);
      }

      return itemsPreenchidos;
    };

    Vue.prototype.$checkTotallyFilled = function checkTotallyFilled(
      isTotalFilled,
      propriedade = "totalmentePreenchido"
    ) {
      this[propriedade] = isTotalFilled;
      return isTotalFilled;
    };
  },
};
